import { render, staticRenderFns } from "./plantation.vue?vue&type=template&id=7ab94fc1&scoped=true"
import script from "./plantation.vue?vue&type=script&lang=ts"
export * from "./plantation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab94fc1",
  null
  
)

export default component.exports